import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { toast } from "react-toastify";
import { Table, Button, Container, Grid, Confirm, Dimmer, Loader, Segment, Header, Icon, Tab, Label } from 'semantic-ui-react'

import FuseContentModal from '../../../components/generic/FuseContentModal';
import TenantCloudDetails from './TenantCloudDetails';
import * as TENANT_CLOUD_ACTIONS from "../../../actions/tenantCloudActions";
import * as QUESTIONNAIRES_ACTIONS from "../../../actions/questionaireActions";


export function TenantCloudsPage(props) {
    const [state, setState] = useState({
        selectedTenantCloud: {},
        deleteTenantCloudCandidate: {},
    });

    const hasPermissions = (category) => {
        return !_.isEmpty(props.userPermissions) && props.userPermissions.hasOwnProperty(category);
    };

    const isAdmin = () => {
        return hasPermissions('Other') && props.userPermissions['Other'].actions.admin;
    };

    const canReadTenantCloud = () => {
        return hasPermissions('Tenant Cloud') && props.userPermissions['Tenant Cloud'].actions.READ || isAdmin();
    };

    const canCreateTenantCloud = () => {
        return hasPermissions('Tenant Cloud') && canReadTenantCloud() && props.userPermissions['Tenant Cloud'].actions.CREATE || isAdmin();
    };

    const canUpdateTenantCloud = () => {
        return hasPermissions('Tenant Cloud') && canReadTenantCloud() && props.userPermissions['Tenant Cloud'].actions.UPDATE || isAdmin();
    };

    const canDeleteTenantCloud = () => {
        return hasPermissions('Tenant Cloud') && canReadTenantCloud() && props.userPermissions['Tenant Cloud'].actions.DELETE || isAdmin();
    };

    const canReadCloudTenants = () => {
        return hasPermissions('Tenant Cloud') && props.userPermissions['Tenant Cloud'].actions['VIEW TENANTS'] || isAdmin();
    };

    useEffect(() => {
        if (!_.isEmpty(props.tenant)) {
            if (props.isPermissionsFetched) {
                if (canReadTenantCloud()) {
                    props.fetchTenantCloudsAction();
                    props.fetchQuestionairesAction(props.tenant);
                } else {
                    toast.error('You do not have permission to view tenant clouds.');
                }
            }
        }
    }, [props.tenant]);

    const confirmDeleteTenantCloud = () => {
        return (
            <Confirm
                content={`Are you sure you want to delete the selected Tenant Cloud: ${state.deleteTenantCloudCandidate.name}?`}
                open={state.showConfirmDeleteTenantCloud}
                onCancel={() => setState((state) => ({ ...state, showConfirmDeleteTenantCloud: false }))}
                onConfirm={() => {
                    props.deleteTenantCloudAction(state.deleteTenantCloudCandidate);
                    setState((state) => ({ ...state, showConfirmDeleteTenantCloud: false, deleteTenantCloudCandidate: {}, selectedTenantCloud: {} }));
                }}
            />
        );
    };

    const handleTenantCloudClick = (tenantCloud) => {
        if (tenantCloud.id == state.selectedTenantCloud.id) return;
        setState((state) => ({ ...state, selectedTenantCloud: tenantCloud }));
    };

    const tenantCloudRender = () => {
        if (!props.fetchingData) {
            if (!props.tenantClouds || props.tenantClouds.length === 0) {
                return (
                    <Segment>
                        <Header icon>
                            <Icon name='cloud' color="black" />
                            There Aren't Any Tenant Clouds
                        </Header>
                    </Segment>
                );
            }

            const sortedTenantClouds = [...props.tenantClouds].sort((a, b) => a.name.localeCompare(b.name));

            return (
                <Table compact selectable size='small'>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell className='nectaPrimaryBg'>Cloud Name</Table.HeaderCell>
                            <Table.HeaderCell className='nectaPrimaryBg'>Cloud Description</Table.HeaderCell>
                            <Table.HeaderCell className='nectaPrimaryBg' />
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {sortedTenantClouds.map((tenantCloud, index) => (
                            <Table.Row
                                key={`${tenantCloud.id}.${index}`}
                                className='clickable'
                                active={tenantCloud.id === state.selectedTenantCloud.id}
                            >
                                <Table.Cell onClick={() => handleTenantCloudClick(tenantCloud)}>{tenantCloud.name}</Table.Cell>
                                <Table.Cell onClick={() => handleTenantCloudClick(tenantCloud)}>{tenantCloud.description}</Table.Cell>
                                <Table.Cell>
                                    {canUpdateTenantCloud() && (
                                        <FuseContentModal
                                            header={`Edit Tenant Cloud: ${tenantCloud.name}`}
                                            size='large'
                                            overflow='visible'
                                            content={<TenantCloudDetails cloud={tenantCloud} bdaction={'edit'} />}
                                            trigger={<Button compact className="warning" icon='edit' size='small' />}
                                            onOpen={() => {
                                                setState((state) => ({ ...state, isEditTenantCloudOpen: true, selectedTenantCloud: tenantCloud }));
                                            }}
                                            onClose={() => {
                                                setState((state) => ({ ...state, isEditTenantCloudOpen: false, selectedTenantCloud: {} }));
                                            }}
                                        />)}
                                    {canDeleteTenantCloud() && (
                                        <Button compact className='danger' icon='trash' size='small' onClick={(e) => deleteTenantCloud(e, tenantCloud)} />
                                    )}
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            );
        } else {
            return (
                <div style={{ height: '200px', margin: '10px 0px' }}>
                    <Dimmer inverted active>
                        <Loader content='Loading' />
                    </Dimmer>
                </div>
            );
        }
    };

    const cloudTenantsRender = () => {
        if (_.isEmpty(state.selectedTenantCloud.tenants) && _.isEmpty(state.selectedTenantCloud)) {
            return null;
        }

        return (
            <Container fluid>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width='8'>
                            <h3>Tenants In Cloud: {state.selectedTenantCloud.name}</h3>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                {_.isEmpty(state.selectedTenantCloud.tenants) && !_.isEmpty(state.selectedTenantCloud) ? (
                    <Segment>
                        <Header>
                            <Icon name='building' color="black" />
                            No Tenants In The Selected Cloud
                        </Header>
                    </Segment>
                ) : (
                    <Table compact size='small'>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className='nectaPrimaryBg' style={{ width: "40%" }}>Tenant Name</Table.HeaderCell>
                                <Table.HeaderCell className='nectaPrimaryBg' style={{ width: "40%" }}>Description</Table.HeaderCell>
                                <Table.HeaderCell className='nectaPrimaryBg' style={{ width: "20%" }}>Status</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {(state.selectedTenantCloud.tenants || []).map((tenant, index) => (
                                <Table.Row key={`${tenant.id}.${index}`}>
                                    <Table.Cell>{tenant.companyName}</Table.Cell>
                                    <Table.Cell>{tenant.description}</Table.Cell>
                                    <Table.Cell>
                                        {tenant.status === "active" ? (
                                            <Label size='mini' as='a' color='green' style={{ marginBottom: 5 }}>
                                                Active
                                            </Label>
                                        ) : (
                                            <Label size='mini' as='a' color='red' style={{ marginBottom: 5 }}>
                                                Inactive
                                            </Label>
                                        )}
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>)}
            </Container>
        );
    }

    const cloudQuestionnairesRender = () => {
        if (_.isEmpty(state.selectedTenantCloud)) {
            return null;
        }

        const questionnaires = state.selectedTenantCloud.questionnaires || [];

        return (
            <Container fluid>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width='8'>
                            <h3>Questionnaires In Cloud: {state.selectedTenantCloud.name}</h3>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                {questionnaires.length === 0 ? (
                    <Segment>
                        <Header>
                            <Icon name='clipboard list' color="black" />
                            No Questionnaires Assigned To The Selected Cloud
                        </Header>
                    </Segment>
                ) : (
                    <Table compact size='small'>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className='nectaPrimaryBg' style={{ width: "30%" }}>Questionnaire Name</Table.HeaderCell>
                                <Table.HeaderCell className='nectaPrimaryBg' style={{ width: "60%" }}>Description</Table.HeaderCell>
                                <Table.HeaderCell className='nectaPrimaryBg' style={{ width: "10%" }}>Status</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {questionnaires.map((questionnaire, index) => (
                                <Table.Row key={`${questionnaire.id}.${index}`}>
                                    <Table.Cell>{questionnaire.name}</Table.Cell>
                                    <Table.Cell>{questionnaire.description}</Table.Cell>
                                    <Table.Cell>
                                        {questionnaire.status === "active" ? (
                                            <Label size='mini' as='a' color='green' style={{ marginBottom: 5 }}>
                                                Active
                                            </Label>
                                        ) : (
                                            <Label size='mini' as='a' color='red' style={{ marginBottom: 5 }}>
                                                Inactive
                                            </Label>
                                        )}
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>)}
            </Container>
        );
    }

    const deleteTenantCloud = (e, tenantCloud) => {
        e.stopPropagation();
        setState((state) => ({ ...state, deleteTenantCloudCandidate: tenantCloud, showConfirmDeleteTenantCloud: true }));
    };

    const removeQuestionnaireFromCloud = (e, questionnaire) => {
        e.stopPropagation();
        // Handle questionnaire removal logic
    };

    const tabListRenderer = () => {
        if (_.isEmpty(state.selectedTenantCloud) || (state.selectedTenantCloud.id < 1)) {
            return;
        }

        const tabs = [];

        tabs.push({
            menuItem: "Tenants",
            render: () => <Tab.Pane>{cloudTenantsRender()}</Tab.Pane>,
        });

        tabs.push({
            menuItem: "Questionnaires",
            render: () => <Tab.Pane>{cloudQuestionnairesRender()}</Tab.Pane>,
        });


        return <Tab
            menuPosition='left'
            defaultActiveIndex={0}
            renderActiveOnly={true}
            panes={tabs}
        />;
    }

    return (
        <Container fluid>
            {confirmDeleteTenantCloud()}
            <Grid>
                <Grid.Row>
                    <Grid.Column width='8'>
                        <h3>Tenant Clouds: </h3>
                    </Grid.Column>
                    <Grid.Column width='8'>
                        {canCreateTenantCloud() && (
                            <FuseContentModal
                                header={`Create Tenant Cloud`}
                                overflow='visible'
                                content={<TenantCloudDetails cloud={state.selectedTenantCloud} bdaction={'add'} />}
                                trigger={<Button compact className="success" icon='add' size='small' floated='right' />}
                                onClose={() => {
                                    setState((state) => ({ ...state, selectedTenantCloud: state.selectedTenantCloud }));
                                }}
                            />)}
                        {canReadTenantCloud() && (
                            <Button compact className='primary' icon='refresh' size='small' floated='right' onClick={(e) => {
                                props.fetchTenantCloudsAction();
                            }}></Button>)}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            {tenantCloudRender()}
            <br></br>
            {tabListRenderer()}
        </Container>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
        fetchingData: state.fetchingData === true,
        tenant: state.tenantManagement.activeTenant,
        userPermissions: _.isEmpty(state.authUserRoles.permissions) ? {} : state.authUserRoles.permissions,
        isPermissionsFetched: state.isPermissionsFetched === true,
        tenantClouds: state.tenantClouds || [],
        cloudTenants: state.cloudTenants || []
    }
}

export default connect(
    mapStateToProps,
    (dispatch, ownProps) => ({
        fetchTenantCloudsAction: () => dispatch(TENANT_CLOUD_ACTIONS.fetchTenantCloudsAction()),
        fetchQuestionairesAction: (tenant) => dispatch(QUESTIONNAIRES_ACTIONS.fetchBaseQuestionairesAction(tenant)),
        deleteTenantCloudAction: (cloud) => dispatch(TENANT_CLOUD_ACTIONS.deleteTenantCloudAction(cloud)),
    })
)(TenantCloudsPage);
